module.exports = __webpack_public_path__ + "static/media/tp.597302e5.png";